import React from 'react';

export default React.memo(function Input({ className = '', ...props }) {
  return (
      <input {...props}
             className={`w-full h-16 rounded-2xl bg-white border border-[#D0D5DD] outline-none px-4 py-3 shadow-sm ${className}`} />
  );
})
